/**
 * ============================================================================================
 *  THE MOCK -> REAL API SWITCH LIVES HERE. This file is the only place that decides.
 * ============================================================================================
 *
 * `DEFAULT_SOURCE` is now `'http'`: every page reads `/api/v1` from a real Postgres through a
 * real session. The Vite dev server proxies `/api` to 127.0.0.1:8080 (vite.config.ts), which is
 * where `pnpm dev` puts h1-core.
 *
 * The mock is kept and still compiles, because it is what the component tests render against —
 * they must not need a database — and because `VITE_H1_API=mock pnpm --filter @h1/console dev`
 * is the fastest way to look at a screen with no server at all. It is NOT a fallback: nothing
 * silently drops back to it, since a console quietly showing invented rows is the single worst
 * failure this project could ship.
 *
 * Author: Danish Khan
 */
import type { Api } from './apiTypes.ts';
import { httpApi } from './httpApi.ts';
import { mockApi } from '../mock/adapter.ts';

export type ApiSource = 'mock' | 'http';

const DEFAULT_SOURCE: ApiSource = 'http';

const fromEnv = import.meta.env['VITE_H1_API'];
export const API_SOURCE: ApiSource = fromEnv === 'http' || fromEnv === 'mock' ? fromEnv : DEFAULT_SOURCE;

export const api: Api = API_SOURCE === 'http' ? httpApi : mockApi;

export { ApiError } from './apiTypes.ts';
export type { Api } from './apiTypes.ts';
